// extracted by mini-css-extract-plugin
module.exports = {"button":"SpecialButton-button-97f4"};